import { createContext } from "react";

export const TankContext = createContext({
  tank: {},
  onChange: () => {},
});
